import { type PropsWithChildren } from 'react';

import { ChartToolbarConfig } from '../../core/types/toolbar.js';
import { HistogramToolbarContext } from '../contexts/HistogramToolbar.context.js';

export const HistogramToolbarProvider = ({
  children,
  config,
}: PropsWithChildren<{ config?: ChartToolbarConfig }>) => (
  <HistogramToolbarContext.Provider value={config ?? {}}>
    {children}
  </HistogramToolbarContext.Provider>
);

HistogramToolbarProvider['displayName'] = 'HistogramToolbarProvider';
